module.exports = __webpack_public_path__ + "static/media/Trasy.31c54084.svg";